import { telemetry } from '../../../@vendor/Posthog';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { pointStep, stringStep } from '../../../concepts/commands/CommandWizard';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { EditorSession } from '../../canvas/EditorSession';
import { MyRoleInfo } from '../../canvas/MyRoleInfo';
import { ProfileModel } from '../../ProfileModel';
import { FollowingInfo } from './FollowingInfo';
import { GesturesController } from './GesturesController';

export const follow = defineCommand(
    'follow',
    'Follow...',
    (r, [userId]: [string?]) => {
        r.call(EditorSession).update(FollowingInfo, { userId });
        telemetry.emit('interaction.follow');
    },
    [
        stringStep('user', 'User ID:'),
    ]
);

export const pingCanvas = defineCommand(
    'pingCanvas',
    'Ping: Canvas',
    (r, [fx, fy, tx, ty]: [number, number, number?, number?]) => {
        const region = (typeof (tx) === 'number' && typeof (ty) === 'number')
            ? Rect.fromPoints([new Point(fx, fy), new Point(tx, ty)])
            : new Rect(fx, fy, 1, 1);
        const me = r.call(ProfileModel);
        const { canParticipate } = r.call(EditorSession).get(MyRoleInfo);
        if (canParticipate) {
            r.call(GesturesController).pingCanvas(me.color, region);
            telemetry.emit('interaction.ping');
        }
    },
    [
        pointStep('from', 'First position:'),
        pointStep('to', 'Second position (optional):'),
    ]
);

export const pingUI = defineCommand(
    'pingUI',
    'Ping: UI',
    (r, [id]: [string]) => {
        const me = r.call(ProfileModel);
        const { canParticipate } = r.call(EditorSession).get(MyRoleInfo);

        if (canParticipate) {
            r.call(GesturesController).pingUI(me.color, id);
            telemetry.emit('interaction.ping');
        }
    },
    [
        stringStep('id', 'UI Element ID:'),
    ]
);
